// extracted by mini-css-extract-plugin
export default {"root":"badge_root__9y3Gw","label":"badge_label__90Uj3","section":"badge_section__RQu+P"};